import styled from 'styled-components';
import GoSafeIconSvg from './go-safe.svg';

const GoSafeIcon = styled(GoSafeIconSvg as React.SFC<React.SVGProps<SVGSVGElement>>)`
  width: ${props => props.width || '2rem'};
  height: ${props => props.height || '2rem'};
  fill: ${props => props.fill || '#647a97'};
  
`;

export default GoSafeIcon;

